/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_StartInputs */

const en_us2_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

const pt_br2_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar`)
};

const es_419_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar`)
};

const pt_pt2_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar`)
};

const fr_fr2_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencer`)
};

const de_de2_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten`)
};

const it_it2_quick_workout_start = /** @type {(inputs: Quick_Workout_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia`)
};

/**
* | output |
* | --- |
* | "Start" |
*
* @param {Quick_Workout_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_start = /** @type {((inputs?: Quick_Workout_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_start(inputs)
	if (locale === "es-419") return es_419_quick_workout_start(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_start(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_start(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_start(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_start(inputs)
	return en_us2_quick_workout_start(inputs)
});
export { quick_workout_start as "quick-workout.start" }